"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.horizontalScrollContainerBy = exports.scrollIntoParentViewHorizontal = void 0;
var helper_1 = require("./helper");
function scrollIntoParentViewHorizontal(child) {
    var scrollParent = child.parentElement;
    var scrollLeft = scrollParent.scrollLeft, parentWidth = scrollParent.offsetWidth;
    var childLeft = child.offsetLeft, childWidth = child.offsetWidth;
    var nextSrollLeft = scrollLeft;
    if (childLeft + childWidth > scrollLeft + parentWidth) {
        nextSrollLeft = childLeft + childWidth - parentWidth;
    }
    if (childLeft < scrollLeft) {
        nextSrollLeft = childLeft;
    }
    if (nextSrollLeft !== scrollLeft) {
        horizontalScrollElementWithAnimation(scrollParent, scrollLeft, nextSrollLeft);
    }
    return nextSrollLeft;
}
exports.scrollIntoParentViewHorizontal = scrollIntoParentViewHorizontal;
function horizontalScrollContainerBy(container, deltaX) {
    var scrollLeft = container.scrollLeft, scrollWidth = container.scrollWidth, offsetWidth = container.offsetWidth;
    var targetLeft = helper_1.castInto(scrollLeft + deltaX, [0, scrollWidth - offsetWidth]);
    horizontalScrollElementWithAnimation(container, scrollLeft, targetLeft);
}
exports.horizontalScrollContainerBy = horizontalScrollContainerBy;
function horizontalScrollElementWithAnimation(element, fromScrollLeft, toScrollLeft) {
    if (Math.abs(fromScrollLeft - toScrollLeft) < 1) {
        return;
    }
    requestAnimationFrame(function () {
        var nextScrollLeft = fromScrollLeft + (toScrollLeft - fromScrollLeft) / 3;
        var nextScrollLeftFixed = toScrollLeft > fromScrollLeft ? Math.ceil(nextScrollLeft) : Math.floor(nextScrollLeft);
        element.scrollLeft = nextScrollLeftFixed;
        horizontalScrollElementWithAnimation(element, nextScrollLeftFixed, toScrollLeft);
    });
}
